import { Trans } from 'react-i18next';
import Header1 from '../../../components/mplat/Header1';

function AccountsHeading() {
    return (
        <Header1>
            <Trans>My accounts</Trans>
        </Header1>
    );
}

export default AccountsHeading;
